/**
 * Code block display — for formulas and VBA code.
 */

import React, { useState } from 'react';
import { Button, Text, Tooltip } from '@fluentui/react-components';
import { CopyRegular, CheckmarkRegular } from '@fluentui/react-icons';

interface CodeBlockProps {
  code: string;
  label?: string;
  language?: string;
}

export const CodeBlock: React.FC<CodeBlockProps> = ({ code, label, language }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      {label && (
        <Text size={200} weight="semibold" style={{ color: 'var(--text-secondary)' }}>
          {label}
          {language && (
            <span style={{ fontWeight: 400, marginLeft: 8, fontSize: 11 }}>{language}</span>
          )}
        </Text>
      )}
      <div
        style={{
          background: '#f5f5f5',
          borderRadius: 6,
          padding: '10px 12px',
          marginTop: 4,
          fontFamily: 'Consolas, monospace',
          fontSize: 13,
          wordBreak: 'break-all',
          whiteSpace: 'pre-wrap',
          position: 'relative',
        }}
      >
        {code}
        <Tooltip content={copied ? 'Copie !' : 'Copier'} relationship="label">
          <Button
            size="small"
            icon={copied ? <CheckmarkRegular /> : <CopyRegular />}
            onClick={handleCopy}
            style={{ position: 'absolute', top: 4, right: 4 }}
            appearance="subtle"
          />
        </Tooltip>
      </div>
    </div>
  );
};
